// src/DateService.ts
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
export var FMT;
(function (FMT) {
    FMT["time"] = "HH:mm";
    FMT["timeline"] = "DD/MM HH:mm";
    FMT["onlyDate"] = "DD/MM/YYYY";
    FMT["onlyDateReverse"] = "YYYY/MM/DD";
    FMT["date"] = "DD/MM/YYYY HH:mm";
    FMT["dateExcel"] = "dd/mm/yyyy hh:mm";
    FMT["dateReverse"] = "YYYY/MM/DD HH:mm";
    FMT["dateCompact"] = "DDMMYYYY_HHmm";
    FMT["display"] = "DD/MM/YYYY HH:mm:ss";
    FMT["utcCompact"] = "YYYYMMDDHHmm";
    FMT["utcCompactUnderscore"] = "YYYYMMDD_HHmm";
    FMT["utcUnderscore"] = "YYYY_MM_DD_HH_mm";
    FMT["dbDate"] = "YYYY-MM-DD";
    FMT["dbDateTime"] = "YYYY-MM-DD HH:mm";
    FMT["dbTimestamp"] = "YYYY-MM-DD HH:mm:ss.SSS";
    FMT["ISODate"] = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    FMT["dbISODate"] = "YYYY-MM-DDTHH:mm:ss.SSS[Z]";
    FMT["simDate"] = "YYYY-MM-DDTHH:00:00.000Z";
    FMT["simulationWithWind"] = "MM-DD-YYYY_HH00";
    FMT["fileName"] = "YYYYMMDD";
    FMT["fileNameFechaHora"] = "YYYYMMDD_HH-mm";
})(FMT || (FMT = {}));
export var DayjsUnit;
(function (DayjsUnit) {
    DayjsUnit["Day"] = "day";
    DayjsUnit["Week"] = "week";
    DayjsUnit["Month"] = "month";
    DayjsUnit["Year"] = "year";
    DayjsUnit["Hour"] = "hour";
    DayjsUnit["Minute"] = "minute";
    DayjsUnit["Second"] = "second";
    DayjsUnit["Millisecond"] = "millisecond";
})(DayjsUnit || (DayjsUnit = {}));
const DateService = {
    getCurrentDayJs() {
        return dayjs();
    },
    toDayjs(input, format = FMT.display) {
        if (!input)
            return dayjs(NaN);
        if (dayjs.isDayjs(input)) {
            return input;
        }
        // Si es timestamp numérico
        if (typeof input === 'number') {
            return dayjs(input); // Dayjs sabe manejar timestamps en ms
        }
        const isIsoUtc = /T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(input);
        if (isIsoUtc) {
            // Caso 1: ISO UTC de la BD
            return dayjs.utc(input).local();
        }
        else {
            // Caso 2: formato local de la UI
            return dayjs(input, format, true); // true = parseo estricto
        }
    },
    toString(input, format = FMT.display) {
        return input.format(format);
    },
};
export default DateService;
